import AlertMessage from "src/components/ui-components/AlertMessage";
import axios from "src/lib/axios";

const API_URLS = {
  GET_USERS_AND_INVITATIONS: `/ConfigUserInvitation/GetUsersAndInvitations`,
  GET_USERS_INVITATION_BY_KEY: `/ConfigUserInvitation/GetUserInvitationByKey`,
  INSERT_USER_INVITATION: `/ConfigUserInvitation/CreateUserInvite`,
  UPDATE_USER_INVITATION: `/ConfigUserInvitation/UpdateUserInvite`,
  INVALIDATE_USER_INVITATION: `/ConfigUserInvitation/InvalidateUserInvite`,
  DELETE_USER_INVITATION: `/ConfigUserInvitation/DeleteUserInvitation`,
  RESEND_USER_INVITATION: `/ConfigUserInvitation/ResendInvitation`,
  VALIDATE_USER_INVITE: `/ConfigUserInvitation/ValidateUserInvite`,
  REGISTER_CONFIG_USER: `/ConfigUser/RegisterUser`,
  ENABLE_DISABLE_CONFIG_USER: `/ConfigUser/EnableDisableConfigUser`
};

export const getConfigUsersList = async () => {
  try
  {
    const usersAndInvitations = await axios.get(API_URLS.GET_USERS_AND_INVITATIONS);
    return usersAndInvitations.data  || [];
  } catch {
    return [];
  }
};

export const getConfigUserInvitationByKey = async (userInvitationKey: string) => {
  try
  {
    const usersAndInvitation = await axios.get(API_URLS.GET_USERS_INVITATION_BY_KEY, {
      params: {
        userInvitationKey
      }
    });
    return usersAndInvitation.data;
  } catch {
    return {};
  }
};

export const insertConfigUserInvitation = async (data): Promise<any> => {
  try
  {
    const res = await axios.post(API_URLS.INSERT_USER_INVITATION, data);
    AlertMessage({ type: 'success', msg: res?.data?.message || 'User invited successfully'});
    return res?.data?.isSuccess;
  } catch(err) {
    Object.entries(err.errors).forEach(([, errMsg]: any) => {
      AlertMessage({ type: 'error', msg: errMsg.errorMessage });
    });
    return false;
  }
};

export const invalidateConfigUserInvitation = async (userInvitationKey: string) => {
  try
  {
    const res = await axios.put(`${API_URLS.INVALIDATE_USER_INVITATION}?userInvitationKey=${userInvitationKey}`);
    AlertMessage({ type: res?.data?.isSuccess ? 'success' : 'error', msg: res?.data?.message || 'User invitation invalidated successfully'});
    return res?.data?.isSuccess;
  } catch(err) {
    Object.entries(err.errors).forEach(([, errMsg]: any) => {
      AlertMessage({ type: 'error', msg: errMsg.errorMessage });
    });
    return false;
  }
};

export const deleteConfigUserInvitation = async (userInvitationKey: string) => {
  try
  {
    const res = await axios.delete(API_URLS.DELETE_USER_INVITATION, { params: {
      userInvitationKey
    }});
    AlertMessage({ type: 'success', msg: res?.data?.message || 'User invitation deleted successfully'});
    return res?.data?.isSuccess;
  } catch(err) {
    Object.entries(err.errors).forEach(([, errMsg]: any) => {
      AlertMessage({ type: 'error', msg: errMsg.errorMessage });
    });
    return false;
  }
};

export const updateConfigUserInvitation = async (data) => {
  try
  {
    const res = await axios.put(API_URLS.UPDATE_USER_INVITATION, data);
    AlertMessage({ type: 'success', msg: res?.data?.message || 'Invitation updated successfully'});
    return res?.data?.isSuccess;
  } catch(err) {
    Object.entries(err.errors).forEach(([, errMsg]: any) => {
      AlertMessage({ type: 'error', msg: errMsg.errorMessage });
    });
    return false;
  }
};

export const resendConfigUserInvitation = async (userInvitationKey) => {
  try
  {
    const res = await axios.put(`${API_URLS.RESEND_USER_INVITATION}?userInvitationKey=${userInvitationKey}`);
    AlertMessage({ type: 'success', msg: res?.data?.message || 'Invitation updated successfully'});
    return res?.data?.isSuccess;
  } catch(err) {
    Object.entries(err.errors).forEach(([, errMsg]: any) => {
      AlertMessage({ type: 'error', msg: errMsg.errorMessage });
    });
    return false;
  }
};

export const validateUserInvite = async (email: string, inviteCode: string, appKey: string) => {
  try
  {
    const res = await axios.get(API_URLS.VALIDATE_USER_INVITE, { 
      params: {
        email,
        inviteCode,
        appKey
      }
    });
    AlertMessage({ type: res.data.isSuccess ? 'success' : 'error', msg: res?.data?.message });
    return res?.data?.isSuccess;
  } catch(err) {
    Object.entries(err.errors).forEach(([, errMsg]: any) => {
      AlertMessage({ type: 'error', msg: errMsg.errorMessage });
    });
    return false;
  }
};

export const registerConfigUser = async (data) => {
  try {
    const res = await axios.post(API_URLS.REGISTER_CONFIG_USER, data);
    AlertMessage({ type: res.data.isSuccess ? 'success' : 'error', msg: res?.data?.message });
    return res?.data?.isSuccess;
  } catch {
    AlertMessage({ type: 'error', msg: 'Failed to register' });
    return false;
  }
};

export const enableDisableConfigUser = async (configUserKey: string, isDisabled: boolean) => {
  try {
    const res = await axios.put(`${API_URLS.ENABLE_DISABLE_CONFIG_USER}?configUserKey=${configUserKey}&isDisabled=${isDisabled}`);
    AlertMessage({ type: res.data.isSuccess ? 'success' : 'error', msg: res?.data?.message });
    return res?.data?.isSuccess;
  } catch {
    AlertMessage({ type: 'error', msg: 'Failed enable/disable user' });
    return false;
  }
};
